import { render, staticRenderFns } from "./dataDownload.vue?vue&type=template&id=bc0cac16&scoped=true&"
import script from "./dataDownload.vue?vue&type=script&lang=js&"
export * from "./dataDownload.vue?vue&type=script&lang=js&"
import style0 from "./dataDownload.vue?vue&type=style&index=0&id=bc0cac16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0cac16",
  null
  
)

export default component.exports